const formatDisplayTitle = title => String(title || '')
  .trim()
  .replace(/\s*(?:<br\s*\/?>|\|)\s*/gi, '<br />')
  .replace(/[ \t\r\n]+/g, ' ');

module.exports = {
  formatDisplayTitle
};
